//请求本地数据

import axios from 'axios'
// import common from '@/utils/common'

// json文件映射 实际请求相对路径 匹配 本地json文件
const jsonMapping = new Map([
  ['/order-parking/findOrderParkingById' , 'order.json'],
  ['/order-parking','orderList.json'],

]);

/**
 * 1、跟车任务列表 /rbapp/task/temporaryList
 * 2、绑定任务 3、解绑任务 4、删除任务关系 /rbapp/task/editCarTaskRelation
 * 5、用车记录列表 /rbapp/task/carRelatedTemporaryList
 * 6、车辆记录与任务绑定 /rbapp/task/bindDelateTask // 有2不用这个方法
 * 7、临时任务单任务单列表 /rbapp/task/unSynchronousTemporaryTask
 * 8、修改临时任务单的标识 /rbapp/task/editUnSynchronousTemporaryTask
 * 9、新增单个临时任务 /rbapp/task/addSingleTemporaryTask
 */
// 请求本地json数据
let TEST_REQUEST = axios.create({
  baseURL: '/test/',
  responseType: 'json',
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})

// 拦截请求
TEST_REQUEST.interceptors.request.use(resqust => {
  let flag
  for (let item of jsonMapping) {
    if (item[0] == resqust.url) {
      resqust.url = item[1]
      flag = true
      break
    }
  }
  if (!flag) {
    // let jsonName
    let arr = resqust.url.split('.')
    if ((arr.length > 1 && arr[arr.length - 1] !== 'json') || arr.length === 1) {
      resqust.url = resqust.url + '.json'
    }
  }
  

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(resqust)
    }, 1000)
  })
}, err => {
  return Promise.reject(err) ;
})

const testRequest = {
  // 测试本地数据用，测试的json文件可放在static/test文件夹
  test (url, params,callback) {
    console.log(`请求 = ${url}`)
    console.log(`请求参数 = ${JSON.stringify(params)}`)
    return TEST_REQUEST.get(url, params).then(res => callback(res.data) ) ;
  }
}

export default testRequest
